var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOdk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 61,
    viewBox: "0 0 64 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22158 0.0839924L7.61352 1.13724C7.61352 1.13724 9.29001 -0.00759423 9.65915 3.79922e-05C10.0283 0.0153024 45.1345 0.244269 45.4191 0.251901C45.6959 0.259534 55.3549 0.549558 55.3549 0.549558C55.3549 0.549558 59.1616 2.41945 59.723 2.89265C60.2767 3.37348 63.9066 9.92956 63.9912 11.0439C64.0834 12.1505 63.4375 32.1317 63.4375 32.1317L62.1378 34.7648L63.3144 35.2456L61.9225 55.616C61.9225 55.616 58.6156 59.913 58.1542 60.0885C57.6851 60.2564 14.9655 60.6228 14.9655 60.6228L13.1121 59.2719L11.351 60.5083C11.351 60.5083 7.45203 60.2946 6.98292 59.8214C6.5215 59.3482 2.53023 52.5937 2.53023 52.5937C2.53023 52.5937 1.59971 35.3296 1.78427 34.9632C1.96884 34.6045 2.24569 31.9333 2.24569 31.9333C2.24569 31.9333 1.87656 30.2618 1.59202 29.5138C1.31516 28.7659 0.93834 20.0041 0.846056 19.1722C0.753772 18.3403 0.0078125 8.54813 0.0078125 8.54813C0.0078125 8.54813 1.86118 3.16741 2.33028 2.71711C2.78401 2.28207 6.22158 0.0839924 6.22158 0.0839924Z",
    fill: "url(#paint0_linear_1_2307)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22158 0.0839924L7.61352 1.13724C7.61352 1.13724 9.29001 -0.00759423 9.65915 3.79922e-05C10.0283 0.0153024 45.1345 0.244269 45.4191 0.251901C45.6959 0.259534 55.3549 0.549558 55.3549 0.549558C55.3549 0.549558 59.1616 2.41945 59.723 2.89265C60.2767 3.37348 63.9066 9.92956 63.9912 11.0439C64.0834 12.1505 63.4375 32.1317 63.4375 32.1317L62.1378 34.7648L63.3144 35.2456L61.9225 55.616C61.9225 55.616 58.6156 59.913 58.1542 60.0885C57.6851 60.2564 14.9655 60.6228 14.9655 60.6228L13.1121 59.2719L11.351 60.5083C11.351 60.5083 7.45203 60.2946 6.98292 59.8214C6.5215 59.3482 2.53023 52.5937 2.53023 52.5937C2.53023 52.5937 1.59971 35.3296 1.78427 34.9632C1.96884 34.6045 2.24569 31.9333 2.24569 31.9333C2.24569 31.9333 1.87656 30.2618 1.59202 29.5138C1.31516 28.7659 0.93834 20.0041 0.846056 19.1722C0.753772 18.3403 0.0078125 8.54813 0.0078125 8.54813C0.0078125 8.54813 1.86118 3.16741 2.33028 2.71711C2.78401 2.28207 6.22158 0.0839924 6.22158 0.0839924Z",
    fill: "url(#paint1_linear_1_2307)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9987 11.9365C62.2376 15.081 57.6465 23.3391 57.6465 23.7894C57.6465 24.3389 58.0156 33.0701 58.0156 33.0701C58.0156 33.0701 61.0148 28.4527 63.6757 24.3084C63.8218 19.5916 63.9756 14.0964 63.9987 11.9365Z",
    fill: "#A4EEFF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M1.57617 29.5293L6.09807 30.8649L2.52977 33.3301L7.14395 30.6589L1.57617 29.5293Z",
    fill: "#4AFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M58.2992 59.9817L57.8839 59.6001L52.6084 55.6466C52.6084 55.6466 41.0806 55.2345 37.4277 55.1124C33.7748 54.9902 20.8859 56.1961 20.6398 56.1961C20.3937 56.1961 13.9492 55.4711 13.9492 55.4711C13.9492 55.4711 13.0725 54.3491 12.3573 54.1812C11.8805 54.0744 8.81979 57.3944 6.82031 59.6383C6.88183 59.7299 6.93567 59.7909 6.96643 59.8214C7.43554 60.2946 11.3345 60.5083 11.3345 60.5083L13.0956 59.2719L14.949 60.6228C14.949 60.6228 57.6686 60.2565 58.1377 60.0886C58.1762 60.0733 58.23 60.0351 58.2915 59.9741L58.2992 59.9817Z",
    fill: "url(#paint2_linear_1_2307)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M42.4418 60.3555C48.2864 60.2868 53.5082 60.2181 56.2075 60.157C56.9688 59.867 57.8839 59.5922 57.8839 59.5922L52.6084 55.6388L37.4277 55.1045C37.72 55.8143 40.7576 58.7527 42.4418 60.3478V60.3555Z",
    fill: "url(#paint3_linear_1_2307)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1234 0.114769C23.0011 0.091872 19.9403 0.0766076 17.318 0.0537109C16.372 1.63358 14.834 4.57962 14.834 4.57962L22.4243 4.99176C22.4243 4.99176 24.6699 2.13731 26.1234 0.107136V0.114769Z",
    fill: "url(#paint4_linear_1_2307)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.722 2.89991C59.1837 2.44198 55.6615 0.709465 55.377 0.564453L51.2012 4.91482C51.2012 4.91482 55.3386 8.30353 55.9999 7.19685C56.3306 6.6397 58.1071 4.73165 59.7912 2.97623C59.7605 2.94571 59.7374 2.91518 59.7143 2.89228L59.722 2.89991Z",
    fill: "url(#paint5_linear_1_2307)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.55477C0 8.55477 0.0230709 8.81427 0.0538321 9.24931L6.1907 10.6078L10.3435 4.90657L6.22146 0.0830078L2.32247 2.72376L2.19943 2.89167C1.59958 3.91438 0 8.54714 0 8.54714V8.55477Z",
    fill: "url(#paint6_linear_1_2307)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2599 35.9702L62.8985 35.0848L57.6768 33.7568L57.3691 41.1906L62.4217 48.1588L63.2599 35.9702Z",
    fill: "url(#paint7_linear_1_2307)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0889 5.0373C10.3581 5.0373 12.5652 5.06783 12.5652 4.83123C12.5652 4.59464 9.65827 3.79922e-05 9.65827 3.79922e-05C9.28914 -0.00759423 7.61265 1.13724 7.61265 1.13724L6.2207 0.0839924C6.2207 0.0839924 9.81977 5.04494 10.0889 5.04494V5.0373Z",
    fill: "url(#paint8_linear_1_2307)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55982 5.57209C9.55982 5.57209 5.99921 9.99114 6.12226 11.51C6.2453 13.0211 7.65263 30.5829 7.65263 31.7201C7.65263 32.8573 9.05226 48.7705 9.05226 48.7705C9.05226 48.7705 11.9823 53.7009 12.3591 54.2046C12.7436 54.7083 15.1584 55.5937 15.1584 55.5937L51.8104 55.2121C51.8104 55.2121 56.7706 52.4339 57.0321 52.1821C57.2859 51.9302 57.2859 50.1595 57.2859 49.7855V34.5058C57.2859 34.5058 58.1779 14.5476 58.1779 14.2957C58.1779 14.0439 56.3938 7.22065 56.3938 7.22065C56.3938 7.22065 47.8652 4.57227 47.2346 4.57227C46.604 4.57227 24.7097 4.69438 23.1794 4.69438C21.649 4.69438 9.55982 5.57972 9.55982 5.57972V5.57209Z",
    fill: "url(#paint9_linear_1_2307)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M9.55982 5.57209C9.55982 5.57209 5.99921 9.99114 6.12226 11.51C6.2453 13.0211 7.65263 30.5829 7.65263 31.7201C7.65263 32.8573 9.05226 48.7705 9.05226 48.7705C9.05226 48.7705 11.9823 53.7009 12.3591 54.2046C12.7436 54.7083 15.1584 55.5937 15.1584 55.5937L51.8104 55.2121C51.8104 55.2121 56.7706 52.4339 57.0321 52.1821C57.2859 51.9302 57.2859 50.1595 57.2859 49.7855V34.5058C57.2859 34.5058 58.1779 14.5476 58.1779 14.2957C58.1779 14.0439 56.3938 7.22065 56.3938 7.22065C56.3938 7.22065 47.8652 4.57227 47.2346 4.57227C46.604 4.57227 24.7097 4.69438 23.1794 4.69438C21.649 4.69438 9.55982 5.57972 9.55982 5.57972V5.57209Z",
    fill: "#034072"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9854 35.9014C56.8469 35.9014 42.666 35.5732 42.666 35.5732C42.666 35.5732 56.4701 36.8326 56.6085 36.8326C56.747 36.8326 56.9854 35.9014 56.9854 35.9014Z",
    fill: "#4AFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.07,
    d: "M33.0834 27.567L6.99023 22.5068C7.3363 26.9564 7.6516 31.177 7.6516 31.7113C7.6516 32.8485 9.05124 48.7617 9.05124 48.7617C9.05124 48.7617 11.9812 53.6921 12.3581 54.1958C12.7426 54.6996 15.1573 55.5849 15.1573 55.5849L28.0847 55.4475C28.8999 51.1048 33.0834 27.567 33.0834 27.567Z",
    fill: "url(#paint10_linear_1_2307)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M47.2259 4.55664C46.5876 4.55664 24.701 4.67876 23.1706 4.67876C22.8861 4.67876 22.2401 4.70929 21.3711 4.76271C25.8469 12.8071 33.3218 26.2169 33.5679 26.5909C33.814 26.9572 48.3718 33.872 57.2694 38.0774V34.4902C57.2694 34.4902 58.1615 14.532 58.1615 14.2801C58.1615 14.0282 56.3774 7.20502 56.3774 7.20502C56.3774 7.20502 47.8488 4.55664 47.2182 4.55664H47.2259Z",
    fill: "url(#paint11_linear_1_2307)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7467 33.1074C56.7467 33.1074 56.2314 34.5041 56.093 34.6415C55.9546 34.7865 42.7195 35.5726 42.9502 35.5726C43.181 35.5726 56.4237 35.9924 56.4698 35.9008C56.5159 35.8092 57.2235 34.7865 57.2235 34.7865L56.7543 33.1074H56.7467Z",
    fill: "url(#paint12_linear_1_2307)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1658 4.57954C39.2204 6.40364 16.8032 23.8051 7.61328 31.0939C7.63635 31.3992 7.64404 31.6129 7.64404 31.7121C7.64404 32.8493 9.04368 48.7625 9.04368 48.7625C9.04368 48.7625 9.80502 50.0447 10.6048 51.3651C17.2569 42.588 36.1289 18.0733 46.5339 4.55664C45.6803 4.55664 44.1115 4.57191 42.1658 4.57954Z",
    fill: "url(#paint13_linear_1_2307)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6761 55.3866C38.7747 46.7851 50.2564 25.6972 57.6391 12.0585C57.1161 9.98249 56.3932 7.20436 56.3932 7.20436C56.3932 7.20436 55.6934 6.98302 54.6783 6.67773L21.1562 55.5163L33.6838 55.3866H33.6761Z",
    fill: "url(#paint14_linear_1_2307)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M54.7853 36.673L33.5755 26.5908L13.25 24.1104L33.0833 27.5677L28.4076 50.6476L34.3907 28.1783L54.7853 36.673Z",
    fill: "url(#paint15_linear_1_2307)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M57.0463 45.1746L55.1699 51.2804L51.4247 53.0052L33.068 53.6387L15.7955 52.7457L11.8273 49.5478L8.85888 43.3199L8.58203 43.3047C8.8435 46.327 9.05883 48.7541 9.05883 48.7541C9.05883 48.7541 11.9888 53.6845 12.3657 54.1882C12.7502 54.692 15.1649 55.5773 15.1649 55.5773L51.8169 55.1957C51.8169 55.1957 56.7772 52.4176 57.0386 52.1657C57.2924 51.9138 57.2924 50.1432 57.2924 49.7692V46.1362C57.1463 45.5333 57.054 45.1669 57.054 45.1669L57.0463 45.1746Z",
    fill: "url(#paint16_linear_1_2307)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M51.8083 55.2032L51.4238 53.0052L55.169 51.2803L57.0224 52.1732L52.4389 54.9285L51.8083 55.2032Z",
    fill: "url(#paint17_linear_1_2307)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M15.789 52.7532L11.8208 49.5553L9.9674 49.334L9.75977 49.9675C10.6518 51.4634 12.0899 53.8446 12.3514 54.1881C12.7359 54.6918 15.1507 55.5771 15.1507 55.5771H15.3506C15.9658 55.3329 15.7813 52.7456 15.7813 52.7456L15.789 52.7532Z",
    fill: "url(#paint18_linear_1_2307)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M56.3938 7.21186C56.3938 7.21186 47.8652 4.56348 47.2346 4.56348C46.604 4.56348 24.7097 4.68559 23.1794 4.68559C21.649 4.68559 9.55982 5.57093 9.55982 5.57093C9.55982 5.57093 5.99921 9.98999 6.12226 11.5088C6.22992 12.7986 7.26042 25.72 7.56804 30.2306L7.7526 30.5512L7.84489 18.7212L8.87539 10.799C8.87539 10.799 12.2514 7.34924 12.6283 7.07448C13.0051 6.79209 32.1539 5.49461 34.5918 5.49461C37.0296 5.49461 49.3264 6.98289 49.6109 6.98289C49.8955 6.98289 55.2402 9.59311 55.2402 9.59311C55.2402 9.59311 57.1167 18.4465 57.3089 19.0952C57.4397 19.5608 57.4781 25.9871 57.4935 29.6735C57.755 23.7509 58.1702 14.4625 58.1702 14.2946C58.1702 14.0427 56.3861 7.21949 56.3861 7.21949L56.3938 7.21186Z",
    fill: "#034072"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.3928 7.21291C56.3928 7.21291 53.3782 6.27414 50.802 5.51855L49.7715 7.0221C50.6943 7.36555 55.247 9.58653 55.247 9.58653L56.5082 7.67084C56.4313 7.38082 56.3851 7.21291 56.3851 7.21291H56.3928Z",
    fill: "url(#paint19_linear_1_2307)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.6273 7.0679C12.6273 7.0679 12.7965 7.0221 13.0195 6.98394L10.2126 5.51855C9.79731 5.54908 9.55122 5.56435 9.55122 5.56435C9.55122 5.56435 7.40563 8.22036 6.50586 10.1208L8.86678 10.7924C8.86678 10.7924 12.2428 7.34266 12.6197 7.0679H12.6273Z",
    fill: "url(#paint20_linear_1_2307)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1911 10.6088V13.5396C6.1911 13.5396 1.97681 22.5456 2.09217 22.3319C2.19983 22.1105 6.62945 15.2187 6.62945 15.2187L6.68328 20.9199C6.68328 20.9199 7.22929 15.0584 7.22929 14.7302C7.22929 14.402 6.79095 10.4409 7.0678 10.3875C7.34465 10.334 10.2362 5.77759 10.2977 5.83102C10.3516 5.88444 17.1882 5.0678 17.1882 5.0678L27.3856 4.5946L15.927 4.52591L17.2421 0.671636L14.835 4.57933L13.0278 4.47248C13.0278 4.47248 9.97473 0.152644 9.6825 0H9.65943C9.58253 0.190806 12.2049 4.74724 12.0434 4.80067C11.8819 4.85409 10.3439 4.90752 10.3439 4.90752L6.22186 0.0839544L9.35951 5.07543L6.1911 10.6088Z",
    fill: "url(#paint21_linear_1_2307)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0914 11.6767C58.0914 11.4707 56.5303 6.54789 56.5303 6.54789C56.5303 6.54789 59.7679 2.88442 59.5295 3.09049C59.2834 3.29656 55.5459 6.22734 55.469 6.14338C55.3921 6.05943 52.2314 5.00618 52.3083 4.88407C52.3929 4.76195 55.2999 0.854253 55.2999 0.854253L51.2009 4.92223C51.2009 4.92223 46.6867 4.31165 46.7252 4.10558C46.7559 3.95293 48.94 1.54878 49.9858 0.396319C49.9397 0.396319 49.9013 0.396319 49.8551 0.396319L45.8638 3.90714L40.3268 3.86898L36.1433 0.182617C35.8664 0.182617 35.5819 0.182617 35.2974 0.182617L35.6127 0.396319C35.6127 0.396319 39.8346 4.1819 39.5117 4.30402C39.181 4.42613 35.2051 4.67036 35.2051 4.67036C35.2051 4.67036 47.225 4.83064 47.5942 4.95276C47.9633 5.07487 51.2855 5.68545 51.2855 5.68545L54.9538 6.86081L56.0074 7.19663C56.0074 7.19663 57.5685 12.8521 57.73 12.8521C57.8915 12.8521 58.0991 15.6989 58.0991 15.6989L58.7143 12.646L63.4285 10.6082C63.4285 10.6082 58.0991 11.8675 58.0991 11.6691L58.0914 11.6767Z",
    fill: "url(#paint22_linear_1_2307)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1075 18.8438L57.846 31.9483C57.846 31.9483 63.8445 23.3239 63.583 23.8429C63.3215 24.3618 58.0229 33.0702 58.0229 33.0702L63.3369 32.1467L57.6768 33.7647L57.5076 51.1815L61.3989 56.318L57.0308 52.1737C57.0308 52.1737 56.5464 34.7951 56.6386 33.8487C56.7232 32.9023 58.1152 18.8438 58.1152 18.8438H58.1075Z",
    fill: "url(#paint23_linear_1_2307)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M6.09807 30.8641L4.35237 30.4062L1.57617 29.5361C1.85302 30.2841 2.22985 31.9555 2.22985 31.9555C2.22985 31.9555 2.13756 32.8027 2.0299 33.6041L6.09807 30.8718V30.8641Z",
    fill: "url(#paint24_linear_1_2307)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81305 23.416V30.0713L8.05888 44.5649C8.05888 44.5649 2.00661 40.8404 2.33729 40.9778C2.66798 41.1075 7.66667 45.6792 7.99736 46.0074C8.32804 46.3356 8.58951 48.8771 8.58951 48.8771L3.32934 52.6016L9.32009 50.1212L12.45 54.2502L9.98146 49.3427C9.98146 49.3427 8.72794 43.8551 8.85867 43.3361C8.98941 42.8171 7.47442 29.3691 7.47442 29.041C7.47442 28.7128 6.81305 23.4236 6.81305 23.4236V23.416Z",
    fill: "url(#paint25_linear_1_2307)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 60.5151L13.0969 59.2787L14.9503 60.6296L14.958 56.6074L11.3281 60.5151Z",
    fill: "url(#paint26_linear_1_2307)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4708 52.9824C54.7171 53.303 51.864 54.6005 51.864 54.6005C51.864 54.6005 32.2845 54.8981 31.4232 54.8981C30.5619 54.8981 20.6645 55.3255 19.5878 55.4324C18.5112 55.5392 15.1582 55.5774 15.1582 55.5774C15.1582 55.5774 20.5568 55.9666 20.6568 56.0735C20.7644 56.1803 18.9341 60.1338 18.9341 60.1338C18.9341 60.1338 21.4104 56.1803 21.8411 56.2872C22.2717 56.394 38.9443 55.4324 38.9443 55.4324L52.61 55.6461L57.8855 59.5996L53.7251 54.7531L55.4708 52.9824Z",
    fill: "#4AFFFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6758 33.7575C57.6758 33.7575 60.7288 34.4749 62.8975 35.0779L62.1362 34.765L63.4358 32.1318L57.6758 33.7499V33.7575Z",
    fill: "url(#paint27_linear_1_2307)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M7.91368 18.1484L6.7832 19.8428C7.09082 23.7505 7.41381 28.0093 7.56761 30.2302L7.75218 30.5508L7.84447 18.7209L7.92137 18.1561L7.91368 18.1484Z",
    fill: "url(#paint28_linear_1_2307)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.3158 19.0799C57.4081 19.4081 57.4619 22.7434 57.4773 25.9642C57.5388 25.9489 57.6003 25.9413 57.6618 25.926C57.9002 20.4766 58.1694 14.4166 58.1694 14.2716C58.1694 14.2182 58.0925 13.89 57.9771 13.4092L56.416 15.0501C56.839 17.004 57.2312 18.7899 57.3081 19.0723L57.3158 19.0799Z",
    fill: "url(#paint29_linear_1_2307)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M10.6595 59.6678C9.72899 60.0341 8.95227 60.2096 8.65234 60.2707C9.89048 60.4386 11.3286 60.5149 11.3286 60.5149L11.4209 60.4462L14.9507 56.5996C14.9507 56.5996 11.8361 59.1946 10.6518 59.6601L10.6595 59.6678Z",
    fill: "#4AFFFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4565 60.6068C16.7413 60.4847 15.6339 60.2862 15.6108 60.2328C15.5724 60.1488 14.9648 56.7754 14.9648 56.7754C14.9802 56.8746 14.9648 59.7978 14.9648 60.622C15.0648 60.622 15.9723 60.622 17.4565 60.5991V60.6068Z",
    fill: "#4AFFFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36018 30.3994L1.58398 29.5293C1.76086 30.0025 1.97619 30.8344 2.10693 31.3916C2.49913 31.3763 4.32173 31.2847 5.6137 31.1855L6.10588 30.8573L4.36018 30.3994Z",
    fill: "url(#paint30_linear_1_2307)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M15.166 42.7333C15.166 42.7333 20.4569 41.3214 22.2719 41.558C24.0868 41.7946 27.0937 42.4204 26.6169 42.8097C26.1401 43.1989 24.5636 43.695 23.6946 43.6721C20.6108 43.5958 15.166 42.7333 15.166 42.7333Z",
    fill: "url(#paint31_linear_1_2307)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M28.4472 42.5798C28.1626 42.5798 27.0322 42.4958 26.3093 42.4424C26.6169 42.5721 26.7476 42.7019 26.6169 42.8087C26.1401 43.198 24.5636 43.6941 23.6946 43.6712C20.6108 43.5948 15.166 42.7324 15.166 42.7324C15.166 42.7324 21.6182 44.2436 23.1409 44.4344C24.6712 44.6252 27.0552 43.0606 27.632 42.9614C28.2088 42.8698 28.8778 42.5798 28.4472 42.5798Z",
    fill: "#4AFFFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M17.5098 42.633C17.5098 42.633 20.7858 41.763 22.6546 41.9843C24.531 42.2056 25.8691 42.6788 25.8691 42.6788L17.5098 42.633Z",
    fill: "url(#paint32_linear_1_2307)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7497 30.5751C36.3171 30.5751 39.2143 27.5298 39.2143 23.7897C39.2143 20.0496 36.313 17 32.7497 17C29.1865 17 26.2852 20.0453 26.2852 23.7854C26.2852 27.5255 29.1865 30.5708 32.7497 30.5708V30.5751ZM32.7497 20.1911C34.6376 20.1911 36.1782 21.8038 36.1782 23.7897C36.1782 25.7755 34.6417 27.3882 32.7497 27.3882C30.8578 27.3882 29.3213 25.7755 29.3213 23.7897C29.3213 21.8038 30.8578 20.1911 32.7497 20.1911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3234 32.1196C41.878 31.086 40.7216 30.6313 39.7367 31.0988C37.5342 32.1454 35.1846 32.6729 32.745 32.6729C30.3055 32.6729 27.9558 32.1411 25.7533 31.0988C24.7685 30.6313 23.6121 31.0903 23.1667 32.1196C22.7212 33.1533 23.1585 34.3671 24.1392 34.8347C25.6838 35.5681 27.2898 36.0957 28.9406 36.413L25.3937 40.5864C24.6745 41.4313 24.7481 42.7266 25.5531 43.4815C26.3581 44.2364 27.5922 44.1592 28.3113 43.3142L32.7409 38.0987L37.1705 43.3142C37.5546 43.7689 38.09 44.0005 38.6293 44.0005C39.0911 44.0005 39.5569 43.8289 39.9288 43.4815C40.7338 42.7266 40.8033 41.4313 40.0882 40.5864L36.5412 36.413C38.1921 36.0957 39.794 35.5681 41.3427 34.8347C42.3275 34.3671 42.7606 33.1533 42.3152 32.1196H42.3234Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2307",
    x1: 25.3166,
    y1: 78.6425,
    x2: 39.5523,
    y2: -40.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2307",
    x1: 25.3166,
    y1: 78.6425,
    x2: 39.5523,
    y2: -40.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2307",
    x1: 38.3198,
    y1: 36.2684,
    x2: 29.2075,
    y2: 74.0872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2307",
    x1: 51.501,
    y1: 40.8551,
    x2: 44.1177,
    y2: 73.0114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2307",
    x1: 15.2646,
    y1: 11.2731,
    x2: 24.0839,
    y2: -4.25509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2307",
    x1: 52.001,
    y1: 10.0208,
    x2: 57.8779,
    y2: -0.344003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_2307",
    x1: -0.845934,
    y1: 16.2481,
    x2: 9.43307,
    y2: -1.84645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_2307",
    x1: 67.1281,
    y1: 25.5293,
    x2: 56.7469,
    y2: 48.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_2307",
    x1: 12.9574,
    y1: -11.6773,
    x2: 7.49129,
    y2: 10.3307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_2307",
    x1: 30.8389,
    y1: -13.0124,
    x2: 37.7775,
    y2: 126.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_2307",
    x1: 49.2946,
    y1: -6.34297,
    x2: -3.73764,
    y2: 70.4936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_2307",
    x1: 30.8609,
    y1: -32.452,
    x2: 47.8995,
    y2: 48.9749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_2307",
    x1: 59.4767,
    y1: 21.7888,
    x2: 43.956,
    y2: 44.2768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_2307",
    x1: 42.9887,
    y1: -16.8212,
    x2: 2.01022,
    y2: 73.7788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_2307",
    x1: 59.254,
    y1: -9.46441,
    x2: 18.2832,
    y2: 81.1431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_2307",
    x1: 26.6465,
    y1: -4.31968,
    x2: 39.0389,
    y2: 54.9214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_2307",
    x1: 31.7529,
    y1: 21.6063,
    x2: 34.1239,
    y2: 69.0118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_2307",
    x1: 53.6386,
    y1: 54.15,
    x2: 49.0248,
    y2: 66.5829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_2307",
    x1: 12.5283,
    y1: 52.9975,
    x2: 8.25591,
    y2: 64.5204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_2307",
    x1: 52.7246,
    y1: -0.854351,
    x2: 53.4517,
    y2: 13.6169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_2307",
    x1: 9.22823,
    y1: -2.04498,
    x2: 10.1069,
    y2: 15.5174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_2307",
    x1: 13.6738,
    y1: -7.63222,
    x2: 16.6128,
    y2: 51.6876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_2307",
    x1: 59.2988,
    y1: -34.0326,
    x2: 43.6207,
    y2: 29.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_2307",
    x1: 86.1002,
    y1: -67.0264,
    x2: 45.5327,
    y2: 96.4861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_2307",
    x1: 6.2365,
    y1: 20.6751,
    x2: 1.8621,
    y2: 38.3135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_2307",
    x1: 31.1221,
    y1: -46.6249,
    x2: -2.12941,
    y2: 87.4011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_2307",
    x1: 11.3281,
    y1: 58.6147,
    x2: 14.958,
    y2: 58.6147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_2307",
    x1: 62.836,
    y1: 27.4075,
    x2: 59.1938,
    y2: 37.5607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_2307",
    x1: 6.391,
    y1: 0.113497,
    x2: 8.48166,
    y2: 41.9015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_2307",
    x1: 56.3084,
    y1: -4.8013,
    x2: 58.4217,
    y2: 37.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_2307",
    x1: 3.99874,
    y1: 27.3617,
    x2: 3.67302,
    y2: 33.2388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_2307",
    x1: 21.1645,
    y1: 37.6732,
    x2: 20.5433,
    y2: 50.6102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_2307",
    x1: 21.801,
    y1: 40.2518,
    x2: 21.5283,
    y2: 45.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 27,
    fill: "white",
    transform: "translate(23 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdk);
export default __webpack_public_path__ + "static/media/odk.svg";
export { ForwardRef as ReactComponent };